import { SVGProps } from 'react';

export const PencilIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7803 1.21967C12.4875 0.926777 12.0126 0.926777 11.7197 1.21967L10.9482 1.99111L12.0089 3.05177L12.7803 2.28033C13.0732 1.98744 13.0732 1.51256 12.7803 1.21967ZM11.3018 3.75888L10.2411 2.69822L2.14058 10.7988C1.84687 11.0925 1.63097 11.4547 1.51239 11.8528L1.24307 12.7569L2.1472 12.4876C2.54528 12.369 2.90754 12.1531 3.20125 11.8594L11.3018 3.75888ZM11.0126 0.512563C11.696 -0.170854 12.804 -0.170854 13.4875 0.512563C14.1709 1.19598 14.1709 2.30402 13.4875 2.98744L3.90836 12.5665C3.49716 12.9777 2.99 13.28 2.43268 13.446L0.642756 13.9792C0.466803 14.0316 0.276279 13.9834 0.146459 13.8535C0.0166393 13.7237 -0.0315921 13.5332 0.0208212 13.3573L0.554008 11.5673C0.720021 11.01 1.02228 10.5029 1.43347 10.0917L11.0126 0.512563Z"
        fill="currentColor"
      />
    </svg>
  );
};
